<script setup lang="ts">
import type { InputMessageValue } from './InputMessageTypes'
import Icon from '@ui/components/icon/Icon.vue'
import { MessageVariety } from '@ui/styles'
import { useI18n } from 'vue-i18n'
import CheckCircle from '~icons/cue-filled/check-circle'
import TriangleExclamation from '~icons/cue-filled/triangle-exclamation'

const props = withDefaults(
  defineProps<{
    variety?: MessageVariety
    message?: InputMessageValue
  }>(),
  {
    variety: MessageVariety.Default,
    message: '',
  },
)

const { t, te } = useI18n()

const icon = computed(() => {
  switch (props.variety) {
    case MessageVariety.Error:
      return TriangleExclamation
    case MessageVariety.Success:
      return CheckCircle
    default:
      return ''
  }
})

function translateMessage(message: InputMessageValue) {
  if (typeof message === 'string') {
    return te(message) ? t(message) : message
  }

  return t(message[0], message[1])
}
</script>

<template lang="pug">
Transition
  .message.min-h-18.flex-unset-center.row-4.typ-12-18-400(v-if="message" :class="{ [variety]: true }")
    Icon.s-16(v-if="icon" :name="icon")
    | {{ translateMessage(message) }}
</template>

<style scoped>
.message {
  &.default {
    color: var(--cue-content-neutral-secondary);
  }

  &.error {
    color: var(--cue-content-error-default);
  }

  &.success {
    color: var(--cue-content-success-default);
  }

  &.mark {
    color: var(--cue-content-neutral-primary);
    justify-content: end;
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
